import type { TreeNodeData, TreeNodeInput } from "./treeTypes";

function convertNode(
  node: TreeNodeInput | null | undefined
): TreeNodeData | null {
  if (!node) {
    return null;
  }
  const { id, name, children, ...rest } = node;
  // Prefer explicit id; fall back to name only when id is absent or empty-string.
  // Using `||` would silently treat id="" as missing, causing key collisions with
  // nodes whose name matches another node's real id.
  const resolvedId = id != null && id !== "" ? id : name;
  if (!resolvedId) {
    return null;
  }
  const out = {
    ...rest,
    id: resolvedId,
    name: name ?? id ?? "",
  } as TreeNodeData;
  if (Array.isArray(children)) {
    // Preserve empty arrays: [] means "branch with no loaded children yet" (shows chevron).
    // null/undefined means leaf (no chevron). Arborist uses Array.isArray(children) for isLeaf.
    out.children = children
      .map(convertNode)
      .filter((c): c is TreeNodeData => c != null);
  }
  return out;
}

export function toTreeData(
  data: TreeNodeInput | TreeNodeInput[] | null | undefined
): TreeNodeData[] {
  if (!data) {
    return [];
  }
  if (Array.isArray(data)) {
    return data.map(convertNode).filter((c): c is TreeNodeData => c != null);
  }
  const root = convertNode(data);
  return root ? [root] : [];
}
